import lawsuits from './Lawsuits'
import resetPassword from './ResetPassword'
import auth from './Auth'
import contractors from './Contractors'
import invoices from './Invoices'
import home from './Home'
import account from './Account'
import config from './Config'
import subscription from './Subscription'
import ksef from './KSeF'

// line below is necessary, because we're using hygen for components and modules.
// prettier-ignore
export const routes = [
  ...home.routes,
  ...invoices.routes,
  ...contractors.routes,
  ...auth.routes,
  ...resetPassword.routes,
  ...account.routes,
  ...config.routes,
  ...lawsuits.routes,
  ...subscription.routes,
  ...ksef.routes
]

// line below is necessary, because we're using hygen for components and modules.
// prettier-ignore
export const translations = [
  ...home.i18n,
  ...lawsuits.i18n,
  ...resetPassword.i18n,
  ...auth.i18n,
  ...contractors.i18n,
  ...invoices.i18n,
  ...account.i18n,
  ...ksef.i18n,
  ...config.i18n,
  ...subscription.i18n,
  ...ksef.i18n
]

export const reducers = {
  [home.name]: home.reducer,
  [lawsuits.name]: lawsuits.reducer,
  [resetPassword.name]: resetPassword.reducer,
  [auth.name]: auth.reducer,
  [contractors.name]: contractors.reducer,
  [invoices.name]: invoices.reducer,
  [account.name]: account.reducer,
  [config.name]: config.reducer,
  [subscription.name]: subscription.reducer,
}
